(function(angular){
	'use strict';

	angular
		.module('plansTeaserModule')
		.controller('PlansTeaserController', [
			'urlFactory',
			PlansTeaserControllerFunction
		]);

	function PlansTeaserControllerFunction(
		urlFactory) {

		var plansTeaser = this;

		plansTeaser.redirectToCorePlans = function() {
			urlFactory.redirect('/start-investing/advanced-plans');
		};

		plansTeaser.starterPlanSelected = function() {
			urlFactory.redirect('/start-investing/starter-plan');
		};
	}
})(window.angular);